<script lang="ts">
  import NotLoggedInContentWrapper from "../../components/NotLoggedInContentWrapper.svelte";
  import { Decode, Encode } from "$shared/lib/query";
  import { writable } from "svelte/store";
  import { type SiteRow } from "$apis/parkito2/index.ts";
  import api, {
    fromApi,
    mapInto,
  } from "$shared/lib/api-parkito2.svelte.ts";
  import { setCrumbs } from "$shared/lib/breadcrumbs";
  import {
    CardInline,
    ComfortCol,
    ListNavigationItem,
    Page,
    ValInputField,
    Ver,
    WithResource,
  } from "$components";
  import { Form, Validate } from "$shared/lib/validation_next";
  import { onMount } from "svelte";

  const siteSearch = fromApi(() =>
    api.publicSiteSearch({
      body: {
        page: 1,
        pageSize: 99999,
        by: "name",
        order: "asc",
      },
    })
  );
  const mapSites = (sites: SiteRow[]): Map<string | null, SiteRow[]> => {
    const query = $queryField.res.value ?? "";
    const filteredSites = sites.filter((s) =>
      s.name.toUpperCase().includes(query.toUpperCase()) ||
      s.city?.toUpperCase().includes(query.toUpperCase()) ||
      s.address?.toUpperCase().includes(query.toUpperCase())
    );

    const map = new Map<string | null, SiteRow[]>();
    for (const site of filteredSites) {
      const city = site.city ?? null;
      const sitesPerCity = map.get(city) ?? [];
      sitesPerCity.push(site);
      map.set(city, sitesPerCity);
    }
    return map;
  };
  onMount(() => {
    $siteSearch.load();

    setCrumbs([
      ["Anläggningar", "#/store"],
    ]);
  });

  const initialQP = Decode.query({
    query: Decode.optional(Decode.text),
    accessCode: Decode.optional(Decode.text),
  });
  const queryField = Form.field(Validate.any(), initialQP.value?.query);

  queryField.subscribe((q) => {
    if (q.res.isOk()) {
      Encode.updateUrlQuery({ query: q.res.value });
    }
  });
</script>

<NotLoggedInContentWrapper>
  <Page backButton={false} title="Hitta anläggning">
    {#snippet headerBottomContent()}
      <div>
        <ValInputField
          limitWidth
          field={queryField}
          img="/icons/magnifier.svg"
          placeholder="Sök på namn / address / ort"
        />
      </div>
    {/snippet}
    {#snippet content()}
      <ComfortCol>
        <WithResource api={siteSearch}>
          {#snippet child(sites)}
            {@const mappedSites = mapSites(sites.items)}
            <Ver margin="none" gap="s">
              {#each mappedSites.keys() as city}
                {@const sitesForCity = mappedSites.get(city) ?? []}
                <CardInline title={city ?? "Annat"}>
                  <div>
                    {#each sitesForCity as site, i}
                      <ListNavigationItem
                        link={`#/store/${site.id}`}
                        isFirst={i === 0}
                        isLast={i + 1 === sitesForCity.length}
                        title={site.name}
                        description={site.address ?? undefined}
                      />
                    {/each}
                  </div>
                </CardInline>
              {/each}
            </Ver>
          {/snippet}
        </WithResource>
      </ComfortCol>
    {/snippet}
  </Page>
</NotLoggedInContentWrapper>
